// @flow
// The pincode constructor. All the pincodes in this application will instantiate from here.
class Pincode {
  constructor(
    code: string,
    valid: boolean,
    serviceable: boolean,
    data: Object
  ) {
    this.code = code;
    this.valid = valid;
    this.serviceable = serviceable;
    this.data = data;
  }
}

Pincode.prototype.validLength = '6'; // Pincode length is 6 PAN India

Pincode.prototype.inputType = 'text'; // Text because backend mostly accepts pincode as string

Pincode.prototype.validRegex = 'onlynumber'; // Only allow integer digits - not even decimal

Pincode.prototype.validatePincode = (pincode: Pincode) =>
  pincode &&
  pincode.code &&
  pincode.code.length === Number(Pincode.prototype.validLength);

export default Pincode;
